import Reflux from 'reflux';
import BaseMixin from 'flux/stores/BaseMixin';
import TeamViewActions from 'flux/actions/TeamViewActions';
import EventViewActions from 'flux/actions/EventViewActions';
import UserActions from 'flux/actions/UserActions';
import IntercomActions from 'flux/actions/IntercomActions';
import IntercomSessionStoreHelper from 'flux/stores/IntercomSessionStoreHelper';
import moment from 'moment';

const onTeamPopulateCompleted = TeamViewActions.populate.completed;
const onEventPopulateCompleted = EventViewActions.populate.completed;
const onLoadFromSessionCompleted = UserActions.loadFromSession.completed;

export default Reflux.createStore({
  listenables: [IntercomActions],

  mixins: [BaseMixin],

  init() {
    this.listenTo(onLoadFromSessionCompleted, 'onLoadFromSessionCompleted');
    this.listenTo(onTeamPopulateCompleted, 'onTeamPopulateCompleted');
    this.listenTo(onEventPopulateCompleted, 'onEventPopulateCompleted');

    this.setState({});
  },

  onLoadFromSessionCompleted(user) {
    IntercomSessionStoreHelper.updateIntercomSettings({
      userCreated: moment(user.createdOn).format('MM/DD/YYYY hh:mma'),
    });
    this.setInState('user', user);
  },

  onUpdateShow(showId) {
    IntercomSessionStoreHelper.updateIntercomSettings({ showId });
  },

  onTeamPopulateCompleted(team) {
    const state = this.getState();

    let teamRole = state.user.teams
      ? state.user.teams.find((e) => {
          return e.team === team._id;
        })
      : null;

    let nextSettings = { teamId: team._id };
    if (teamRole)
      nextSettings.teamRole =
        teamRole.role === 'admin' ? 'team admin' : teamRole.role;

    IntercomSessionStoreHelper.updateIntercomSettings(nextSettings);
    this.setInState('team', team);
  },

  onEventPopulateCompleted(event) {
    const state = this.getState();

    let eventRole = state.user.events
      ? state.user.events.find((e) => {
          return e.event === event._id;
        })
      : null;

    let nextSettings = { eventId: event._id };
    if (eventRole) nextSettings.eventRole = eventRole.role;

    IntercomSessionStoreHelper.updateIntercomSettings(nextSettings);
    this.setInState('event', event);
  },

  onUpdateSettings(changes) {
    IntercomSessionStoreHelper.updateIntercomSettings(changes);
  },
});
